/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
export var EuiRangeLabel = ({
  children,
  disabled,
  side = 'max'
}) => {
  const classes = classNames('euiRangeLabel', `euiRangeLabel--${side}`, {
    'euiRangeLabel--isDisabled': disabled
  });
  return <label className={classes}>{children}</label>;
};
EuiRangeLabel.propTypes = {
  /**
     * ReactNode to render as this component's content
     */
  children: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,
  disabled: PropTypes.bool,
  side: PropTypes.oneOf(["min", "max"])
};

try {
  EuiRangeLabel.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/form/range/range_label.tsx',
    description: '',
    displayName: 'EuiRangeLabel',
    methods: [],
    props: {
      children: {
        defaultValue: null,
        description: "ReactNode to render as this component's content",
        name: 'children',
        parent: {
          fileName: 'app/src/components/form/range/range_label.tsx',
          name: 'EuiRangeLabelProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_label.tsx',
          name: 'EuiRangeLabelProps'
        }, {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string | number'
        }
      },
      disabled: {
        defaultValue: null,
        description: '',
        name: 'disabled',
        parent: {
          fileName: 'app/src/components/form/range/range_label.tsx',
          name: 'EuiRangeLabelProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_label.tsx',
          name: 'EuiRangeLabelProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      side: {
        defaultValue: {
          value: 'max'
        },
        description: '',
        name: 'side',
        parent: {
          fileName: 'app/src/components/form/range/range_label.tsx',
          name: 'EuiRangeLabelProps'
        },
        declarations: [{
          fileName: 'app/src/components/form/range/range_label.tsx',
          name: 'EuiRangeLabelProps'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"max" | "min"',
          value: [{
            value: '"max"'
          }, {
            value: '"min"'
          }]
        }
      }
    },
    extendedInterfaces: ['EuiRangeLabelProps']
  };
} catch (e) {}